<template>
    <div>
        <div class="row">
            <div class="sm-12">
                <p>&nbsp;</p>
                <p>Você pode pagar o boleto do seu aluguel ou das despesas do seu condomínio com cartão de crédito, em até 12 vezes.</p>
                <p>Consulte, abaixo, a melhor opção de parcelamento.</p>
            </div>

            <div class="sm-12">
                <div class="responsive-table">
                    <table border="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>Parcelas</th>
                                <th align="right">Valor (R$)</th>
                                <th align="right">Total (R$)</th>
                                <!--
                            <th></th>
                                -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="parcela in parcelas"
                                :key="parcela.id"
                                :class="{selected: installments == parcela.parcela}"
                                @click="installments = parcela.parcela"
                            >
                                <td>{{ parcela.parcela == 1 ? 'Rotativo' : parcela.parcela }}</td>
                                <td align="right">{{ parcela.valor | number_format }}</td>
                                <td align="right">{{ parcela.total | number_format }}</td>
                                <!--
                            <td align="right">                            
                                <input type="radio"  :checked="installments == parcela.parcela"  />
                            </td>
                                -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            

            <div class="sm-12 termos">
                
                <p>
                    <b>Leia os termos e condições</b>
                </p>
                <p>Esse serviço está sujeito a encargos administrativos de transação, e de juros e IOF desde o momento de pagamento do boleto e que são devidos à operadora de seu cartão de crédito. Antes da contratação, consulte o CET (Custo Efetivo Total).</p>
                <p>A Imobiliária {{ imobiliaria }} não se responsabiliza pelos encargos exigidos pela operadora de seu cartão de crédito. Ao aceitar o pagamento parcelado de seu boleto de aluguel ou condomínio através de seu cartão de crédito, você estará aceitando arcar com o pagamento dos encargos administrativos e financeiros que serão cobrados pela integradora e administradora do cartão de crédito, declarando também ter ciência que tais encargos não resultarão em qualquer benefício financeiro para locador, condomínio ou imobiliária, pois reverterão integralmente para as referidas empresas.</p>
                <p>Bandeiras aceitas para esta operação: Visa, Mastercard, HiperCard.</p>
                <p>Para efetivar a operação você deve se dirigir à sua unidade de atendimento.</p>
                <p>Salientamos que trata-se de uma simulação e que os valores, percentuais e opções listadas acima deverão ser confirmados e validados no ato da efetivação da transação em sua unidade de atendimento.</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["boleto"],
    data() {
        return {
            juros: [
                4.04,
                5.24,
                5.91,
                6.58,
                7.25,
                7.92,
                8.84,
                9.51,
                10.18,
                10.85,
                11.52,
                12.19
            ]
        };
    },
    filters: {
        number_format(value) {
            return new Intl.NumberFormat("pt-BR", {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        }
    },
    computed: {
        valor() {
            return this.boleto.valorAtualizado;
        },
        empresa() {
            return this.$store.state.empresa;
        },
        imobiliaria() {
            return this.empresa.title
        },
        valor_total() {
            let parcelas = this.parcelas;
            let parcela = parcelas[this.installments - 1];
            if (!parcela) {
                return 0.0;
            }
            return parcela.total;
        },
        parcelas() {
            let juros = this.juros;
            let valor = +this.valor;

            let parcelas = juros.map((taxa, i) => {
                let parcela = i + 1;
                let total = valor / (1 - taxa / 100);
                let valor_parcela = Math.ceil((100 * total) / parcela) / 100;
                total = Math.round(valor_parcela * parcela * 100) / 100;
                return {
                    id: `${i}.${valor_parcela}`,
                    parcela,
                    total,
                    valor: valor_parcela
                };
            });
            return parcelas;
        }
    }
};
</script>
<style lang="less" scoped>
.termos {
    p {
        text-align: justify;
    }
}
table {
    width: 100%;
}
</style>